class Point {
  constructor(x, y) {
    this.x = x; // Longitude
    this.y = y; // Latitude
  }
}

export default Point;
